<template>
    <div class="container-fluid">
        <b-card no-body class="my-2">
            <b-card-header class="">
                <b-card-title class="card-title-page-garden-help-default my-1">Jobs
                </b-card-title>
            </b-card-header>
        </b-card>

        <b-tabs pills class="tab-jobs-garden-help mt-3" v-model="tabIndex" @input="changeTab">
            <b-tab title="New Jobs" lazy>
                <JobsTable type="pending" />
            </b-tab>
            <b-tab title="Current Jobs" lazy>
                <JobsTable type="current" />
            </b-tab>
            <b-tab title="History" lazy>
                <JobsTable type="history" />
            </b-tab>
            <b-tab title="Pending Requests" lazy>
                <JobsTable type="assigned" />
            </b-tab>
        </b-tabs>

    </div>
</template>


<script>
import axios from "axios";
import $ from "jquery";

import JobsTable from "./JobsTable.vue";

export default {
    name: "GardenHelpAllJobsAdmin",
    components: { JobsTable },
    data() {
        return {
            client_name: "GARDENHELP",
            tabIndex: 0
        }
    },
    methods: {
        changeTab(tabIndex) {
            console.log("change tab", tabIndex)
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/my_jobs/IndexAdmin.vue